import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../picflow-storyblok';

export const storyblokAllowStickyHeaderResolver: ResolveFn<unknown> = route => {
  return inject(PICFLOW_STORYBLOK)
    .getUniqueComponentsList(route)
    .pipe(map(components => !components.has('ProductComparisonList')));
};
